export const validateMobile = (rule, value, callback) => {
  if (!(/^1([0-9][0-9])\d{8}$/.test(value))) {
    callback(new Error('请输入正确的手机号格式'));
  }
  callback();
};
export const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入密码'));
  } else {
    if (this.ruleForm.checkPass !== '') {
      this.$refs.ruleForm.validateField('checkPass');
    }
    callback();
  }
};